import React, { useState } from "react";
import PropTypes from "prop-types";

import { useIntl } from "react-intl";
import { connect } from "react-redux";

import Button from "../../UI/Button/Button";

import Card from "../../UI/Card/Card";
import ErrorPanel, { ErrorSize } from "../../UI/ErrorPanel/ErrorPanel";
import * as UserActions from "../../../middleware/Store/Actions/UserActions";
import * as ErrorUtils from "../../Utils/ErrorUtils";

import { faCheck, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "SETTINGS-PASSWORD";

const Password = (props) => {

    const intl = useIntl();

    const [oldPwdShown, setOldPwdShown] = useState(false);
    const [newPwdShown, setNewPwdShown] = useState(false);

    const [oldPwdValid, setOldPwdValid] = useState(true);
    const [newPwdValid, setNewPwdValid] = useState(true);

    const [oldPwd, setOldPwd] = useState("");
    const [newPwd, setNewPwd] = useState("");

    const [progress, setProgress] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const handleSubmit = (e) => {
        LogService.trace(LOG_TAG, "handleSubmit");

        setProgress(true);
        props.updateUserPassword(props.user, oldPwd, newPwd)
            .then(() => {
                LogService.debug(LOG_TAG, "handleSubmit success", "Update password succefully and clear input...");
                setProgress(false);
                setErrorMessage("");
                // "Password successfully updated"
                clearForm();
            })
            .catch((errorPayload) => {
                LogService.debug(LOG_TAG, "handleSubmit error");
                setProgress(false);
                setNewPwdValid(false);
                setOldPwdValid(false);
                setErrorMessage(ErrorUtils.getPrettyErrorMessage(errorPayload, intl));
            });
    }

    const handleNewPasswordChange = (e) => {
        setNewPwd(e.target.value);
        setNewPwdValid(true);
    }

    const handleOldPasswordChange = (e) => {
        setOldPwd(e.target.value);
        setOldPwdValid(true);
    }

    const clearForm = () => {
        setNewPwd("");
        setOldPwd("");
    }

    LogService.trace(LOG_TAG, "render");
    let disableSubmitBtn = (oldPwd.length < 7 || newPwd.length < 7 || progress);

    return (
        <Card title={intl.messages.settingsPwdTitle}>
            <form>
                <label className="input-label" htmlFor="inputCurrentPwd">{intl.messages.settingsCurrentPwd}</label>
                <div className="input-group mb-3">
                    <input
                        id="inputCurrentPwd"
                        value={oldPwd}
                        placeholder={intl.messages.settingsCurrentPwd}
                        type={oldPwdShown ? "text" : "password"}
                        className={(errorMessage && !oldPwdValid) ? "form-control is-invalid" : "form-control "}
                        autoComplete="current-password"
                        onChange={handleOldPasswordChange}
                    >
                    </input>
                    <div className="input-group-append">
                        <button className="btn input-btn" type="button" onClick={() => setOldPwdShown(!oldPwdShown)}>
                            <FontAwesomeIcon icon={oldPwdShown ? faEyeSlash : faEye} />
                        </button>
                    </div>
                </div>

                <label className="input-label" htmlFor="inputNewPwd">{intl.messages.settingsNewPwd}</label>
                <div className="input-group mb-3">
                    <input
                        id="inputNewPwd"
                        value={newPwd}
                        placeholder={intl.messages.settingsNewPwd}
                        type={newPwdShown ? "text" : "password"}
                        className={(errorMessage && !newPwdValid) ? "form-control is-invalid" : "form-control"}
                        autoComplete="new-password"
                        aria-describedby="basic-addon2"
                        onChange={handleNewPasswordChange}
                    >
                    </input>
                    <div className="input-group-append">
                        <button className="btn input-btn" type="button" onClick={() => setNewPwdShown(!newPwdShown)}>
                            <FontAwesomeIcon icon={newPwdShown ? faEyeSlash : faEye} />
                        </button>
                    </div>
                </div>

                <div className="panel bg-fog mb-3">
                    {intl.messages.settingsPwdMessage}
                </div>

                <Button
                    label={intl.messages.apply}
                    icon={faCheck}
                    className="btn-submit"
                    spinner={progress}
                    disabled={disableSubmitBtn}
                    onClick={handleSubmit}
                />

                {(errorMessage.length > 0) &&
                    <div className="col-9 float-right pr-0">
                        <ErrorPanel size={ErrorSize.Small}>{errorMessage}</ErrorPanel>
                    </div>
                }

            </form>
        </Card>
    );
}

Password.propTypes = {
    user: PropTypes.object
};

const mapStateToProps = state => {
    return {
        user: state.contacts.user
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateUserPassword: (user, oldPwd, newPwd) => dispatch(UserActions.updateUserPassword(user, oldPwd, newPwd)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Password);